import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => ({
    year: [
        { value: null, text: $t('data.salaries.(Seleccionar)', '(Seleccionar)'), disabled: true },
        { value: "0 €", text: "0 €" },
        { value: "1.000 €", text: "1.000 €" },
        { value: "2.000 €", text: "2.000 €" },
        { value: "3.000 €", text: "3.000 €" },
        { value: "4.000 €", text: "4.000 €" },
        { value: "5.000 €", text: "5.000 €" },
        { value: "6.000 €", text: "6.000 €" },
        { value: "7.000 €", text: "7.000 €" },
        { value: "8.000 €", text: "8.000 €" },
        { value: "9.000 €", text: "9.000 €" },
        { value: "10.000 €", text: "10.000 €" },
        { value: "12.000 €", text: "12.000 €" },
        { value: "14.000 €", text: "14.000 €" },
        { value: "16.000 €", text: "16.000 €" },
        { value: "18.000 €", text: "18.000 €" },
        { value: "21.000 €", text: "21.000 €" },
        { value: "24.000 €", text: "24.000 €" },
        { value: "27.000 €", text: "27.000 €" },
        { value: "30.000 €", text: "30.000 €" },
        { value: "33.000 €", text: "33.000 €" },
        { value: "36.000 €", text: "36.000 €" },
        { value: "39.000 €", text: "39.000 €" },
        { value: "40.000 €", text: "40.000 €" },
        { value: "42.000 €", text: "42.000 €" },
        { value: "44.000 €", text: "44.000 €" },
        { value: "48.000 €", text: "48.000 €" },
        { value: "50.000 €", text: "50.000 €" },
        { value: "52.000 €", text: "52.000 €" },
        { value: "54.000 €", text: "54.000 €" },
        { value: "56.000 €", text: "56.000 €" },
        { value: "58.000 €", text: "58.000 €" },
        { value: "60.000 €", text: "60.000 €" },
        { value: "62.000 €", text: "62.000 €" },
        { value: "64.000 €", text: "64.000 €" },
        { value: "66.000 €", text: "66.000 €" },
        { value: "68.000 €", text: "68.000 €" },
        { value: "70.000 €", text: "70.000 €" },
        { value: "72.000 €", text: "72.000 €" },
        { value: "74.000 €", text: "74.000 €" },
        { value: "76.000 €", text: "76.000 €" },
        { value: "78.000 €", text: "78.000 €" },
        { value: "80.000 €", text: "80.000 €" },
        { value: "82.000 €", text: "82.000 €" },
        { value: "84.000 €", text: "84.000 €" },
        { value: "86.000 €", text: "86.000 €" },
        { value: "88.000 €", text: "88.000 €" },
        { value: "90.000 €", text: "90.000 €" },
        { value: "92.000 €", text: "92.000 €" },
        { value: "94.000 €", text: "94.000 €" },
        { value: "96.000 €", text: "96.000 €" },
        { value: "98.000 €", text: "98.000 €" },
        { value: "100.000 €", text: "100.000 €" },
        { value: "105.000 €", text: "105.000 €" },
        { value: "110.000 €", text: "110.000 €" },
        { value: "115.000 €", text: "115.000 €" },
        { value: "120.000 €", text: "120.000 €" },
        { value: "125.000 €", text: "125.000 €" },
        { value: "130.000 €", text: "130.000 €" },
        { value: "135.000 €", text: "135.000 €" },
        { value: "140.000 €", text: "140.000 €" },
        { value: "145.000 €", text: "145.000 €" },
        { value: "150.000 €", text: "150.000 €" },
        { value: "155.000 €", text: "155.000 €" },
        { value: "160.000 €", text: "160.000 €" },
        { value: "165.000 €", text: "165.000 €" },
        { value: "170.000 €", text: "170.000 €" },
        { value: "175.000 €", text: "175.000 €" },
        { value: "180.000 €", text: "180.000 €" },
        { value: "185.000 €", text: "185.000 €" },
        { value: "190.000 €", text: "190.000 €" },
        { value: "195.000 €", text: "195.000 €" },
        { value: "200.000 €", text: "200.000 €" },
        { value: "210.000 €", text: "210.000 €" },
        { value: "220.000 €", text: "220.000 €" },
        { value: "230.000 €", text: "230.000 €" },
        { value: "240.000 €", text: "240.000 €" }
    ],
    month: [
        { value: null, text: $t('data.salaries.(Seleccionar)', '(Seleccionar)'), disabled: true },
        { value: "0 €", text: "0 €" },
        { value: "100 €", text: "100 €" },
        { value: "200 €", text: "200 €" },
        { value: "300 €", text: "300 €" },
        { value: "400 €", text: "400 €" },
        { value: "500 €", text: "500 €" },
        { value: "600 €", text: "600 €" },
        { value: "700 €", text: "700 €" },
        { value: "800 €", text: "800 €" },
        { value: "900 €", text: "900 €" },
        { value: "1000 €", text: "1000 €" },
        { value: "1250 €", text: "1250 €" },
        { value: "1500 €", text: "1500 €" },
        { value: "1750 €", text: "1750 €" },
        { value: "2000 €", text: "2000 €" },
        { value: "2250 €", text: "2250 €" },
        { value: "2500 €", text: "2500 €" },
        { value: "2750 €", text: "2750 €" },
        { value: "3000 €", text: "3000 €" },
        { value: "3250 €", text: "3250 €" },
        { value: "3500 €", text: "3500 €" },
        { value: "3750 €", text: "3750 €" },
        { value: "4000 €", text: "4000 €" },
        { value: "4250 €", text: "4250 €" },
        { value: "4500 €", text: "4500 €" },
        { value: "4750 €", text: "4750 €" },
        { value: "5000 €", text: "5000 €" },
        { value: "5250 €", text: "5250 €" },
        { value: "5500 €", text: "5500 €" },
        { value: "5500 €", text: "5500 €" },
        { value: "5500 €", text: "5500 €" },
        { value: "5750 €", text: "5750 €" },
        { value: "6000 €", text: "6000 €" }
    ],
    hour: [
        { value: null, text: $t('data.salaries.(Seleccionar)', '(Seleccionar)'), disabled: true },
        { value: "0 €", text: "0 €" },
        { value: "3 €", text: "3 €" },
        { value: "6 €", text: "6 €" },
        { value: "9 €", text: "9 €" },
        { value: "12 €", text: "12 €" },
        { value: "15 €", text: "15 €" },
        { value: "18 €", text: "18 €" },
        { value: "21 €", text: "21 €" },
        { value: "23 €", text: "23 €" },
        { value: "25 €", text: "25 €" },
        { value: "30 €", text: "30 €" },
        { value: "35 €", text: "35 €" },
        { value: "40 €", text: "40 €" },
        { value: "45 €", text: "45 €" },
        { value: "50 €", text: "50 €" },
        { value: "75 €", text: "75 €" },
        { value: "100 €", text: "100 €" },
        { value: "120 €", text: "120 €" },
        { value: "150 €", text: "150 €" },
        { value: "200 €", text: "200 €" },
        { value: "300 €", text: "300 €" }
    ]
});
